<script setup lang="ts">
import { onMounted, ref, onUnmounted, watch, computed } from 'vue';
import { useShowImage } from '@/components/useShowImage';
import { useDebounceFn } from '@vueuse/core';

interface Props {
  images: any;
  alt: string;
  class: string;
}
const props = defineProps<Props>();

const images = computed(() => props.images);

const { renderImage } = useShowImage();
const imageRenderByScreen = ref();

if (images.value) {
  imageRenderByScreen.value = renderImage(images?.value);
}

const checkScreenWidth = useDebounceFn(() => {
  imageRenderByScreen.value = renderImage(images?.value);
}, 200);

watch(images, () => {
  checkScreenWidth();
});

onMounted(() => {
  window.addEventListener('resize', checkScreenWidth);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkScreenWidth);
});
</script>
<template>
  <img v-if="imageRenderByScreen" :src="imageRenderByScreen" :alt="props.alt" :class="props.class" />
</template>

<style lang="scss" scoped>
.cover {
  object-fit: cover;
}
</style>
